/*
 * @Author: Finget
 * @Date: 2020-04-24 10:50:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-01 15:49:54
 * @FilePath: /sdk/find_password/src/util/request.js
 */
import Vue from "vue";
import axios from "axios";
import router from "@/router";
import { Toast } from "vant";
import storage from "@/utils/storage";
import eventBus from "@/utils/eventBus";
import { getWasmAuth, isWasmReady, getWasmError } from "@/utils/wasm";

// const location = window.location;


// import qs from 'qs';
const service = axios.create({
  // api base_url
  // baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: 改为根据域名来作为接口请求地址
  // baseURL: location.origin,
  // 请求超时时间，
  timeout: 60000,
  withCredentials: true,
});
service.interceptors.request.use(async (config) => {
  // 添加标准请求头
  if (storage.getItem("token")) {
    config.headers["Authorization"] = storage.getItem("token");
  }
  config.headers["Accept-Language"] = storage.getItem("lang") || "zh";

  // 集成 WASM 签名（WASM已在main.js中初始化）
  if (isWasmReady()) {
    try {
      // 根据请求方法和数据格式准备参数字符串
      let params = "";
      if (config.method === "get") {
        // GET 请求：query string 格式 (key=value&key=value)
        if (config.params && Object.keys(config.params).length > 0) {
          const searchParams = new URLSearchParams();
          for (const key in config.params) {
            const value = config.params[key];
            if (value !== null && value !== undefined) {
              searchParams.append(key, value);
            }
          }
          searchParams.sort();
          params = searchParams.toString();
        }
      } else if (config.method === "post") {
        // POST 请求：JSON 或 Form 格式
        if (config.data) {
          // 如果已经是字符串，直接用；如果是对象，转为 JSON String
          params = typeof config.data === "string" ? config.data : JSON.stringify(config.data);
        }
      }

      // 调用 WASM 生成签名
      const authData = getWasmAuth(config.method.toUpperCase(), params);

      // 添加 WASM 生成的签名头
      config.headers["X-Yingxiong-Nonce"] = authData.nonce;
      config.headers["X-Yingxiong-Timestamp"] = authData.ts;
      config.headers["X-Yingxiong-Signature"] = authData.sign;
    } catch (error) {
      console.error("WASM auth generation failed:", error);
    }
  } else {
    console.warn("WASM not ready, skipping signature. Error:", getWasmError());
  }

  return config;
});

service.interceptors.response.use((response) => {
  const config = response.config || "";
  const res = response.data;
  if (res.code === 0 || res.code === 10) {
    if (config && config.successNotice) {
      Toast.success(res.msg);
    }
    return res;
  } else {
    if (res.code === 401) {
      storage.removeItem("token");
      // router.replace({
      //   name: 'Login',
      //   query: {
      //     redirect: router.currentRoute.fullPath
      //   }
      // });
      eventBus.$emit("showLogin");
      if (config && config.errNotice) {
        Toast.fail(res.msg);
      }
    } else if (String(res.code)[0] === "5") {
      // 500的错
      eventBus.$emit("showErrorModal");
    } else if (res.code === 403) {
      if (router.currentRoute.name !== "SelectGame") {
        router.replace({
          name: "SelectGame",
        }).catch(() => {});
      }
    } else {
      if (config && config.errNotice) {
        Toast.fail(res.msg);
      }
    }

    return res;
  }
});

// const productId = Vue.prototype.$obj.productId;

function get(url, params = {}, errNotice = true, successNotice = false) {
  return new Promise((resolve, reject) => {
    const game_id = storage.getGameId();
    service({
      url: url,
      method: "get",
      params: Object.assign(
        {
          game_id:
            game_id && Number(game_id) && Number(game_id) !== 0
              ? Number(game_id)
              : null,
          lang: storage.getItem("lang"),
        },
        params || {}
      ),
      errNotice,
      successNotice,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
function post(url, params = {}, errNotice = true, successNotice = false) {
  return new Promise((resolve, reject) => {
    const game_id = storage.getGameId();
    service({
      url: url,
      method: "post",
      data: Object.assign(
        {
          game_id:
            game_id && Number(game_id) && Number(game_id) !== 0
              ? Number(game_id)
              : null,
          lang: storage.getItem("lang"),
        },
        params
      ),
      errNotice,
      successNotice,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

Vue.prototype.$http = service;

export default {
  get,
  post,
};
